import * as React from 'react';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { outlinedInputClasses } from '@mui/material';
import { getRequest, postRequest, putRequest } from "../../services/ApiServices";
import { useState, useEffect } from "react";
import { ToastError, ToastSuccess } from "../../services/ToastMsg";
import { FilterObj } from '../CommonComponents/globalfilterObj';
import { getCookie } from "../../services/Cookies";
export default function ReportStatus(props) {
    //reportstatus
    const [formObj, setFormObj] = useState(FilterObj);
    const [GlobalFilterSettingValue, setGlobalFilterSettingValue] = React.useState(localStorage.getItem('GlobalFilterSetting'));
    const [reportStatus, setReportStatus] = React.useState([]);
    const [selectedvalue, setselectedvalue] = React.useState([]);
    const { globalfilter } = props;
    const autoTextReportStatus = (event) => {
       // 
        let result = [
          
            { id: "Critical", name: 'Critical' },
            { id: "Warning", name: 'Warning' },
            { id: "Satisfactory", name: 'Satisfactory' },
            { id: "Other", name: 'Other' },
        ]
        if (selectedvalue) {
            selectedvalue.forEach((val, i) => {
                result = result.filter((ele) => ele.name != val.name)
            })
        }
        setReportStatus(result);
        // let searchStr = event.target.value;
        // setValue(searchStr);
        // //console.log(searchStr,"SEARCH");
        // const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Customer/${searchStr}`;
        // getRequest(url)
        //     .then((res) => {
        //         // //console.log(res);
        //         if (res.status == 200) {
        //             let totalArray = [];
        //             res.data.map((item) => {
        //                 if (item.customerName || item.customerkeys) {
        //                     totalArray.push(item);
        //                 }
        //             });
        //             setCustomerDetailsBySearch(totalArray);
        //         } else {
        //             ToastError(res.data.message);
        //         }
        // })
        // .catch((error) => {
        //     //console.log(error);
        //     // ToastError(error.response.data.message);
        // });
    }
    const handleChange = (event, newValue) => {
        props.onChange(newValue)
        const filteredreportstatus= {
            ...formObj,
            Fqtreportstatus: newValue
        };
        setFormObj(filteredreportstatus);
        setselectedvalue(newValue);
    }
    const defaultValue = (val) => {
        //
        if (val !== "" && val !== undefined && val !== "null") {
            let Obj = JSON.parse(val);
            setFormObj(Obj);
            setselectedvalue(Obj.Fqtreportstatus);
            console.log('getcookievalue', formObj)
        }else{
            setFormObj({});
        }
    }
    React.useEffect(() => {
        //
        defaultValue(GlobalFilterSettingValue);
        autoTextReportStatus();
    }, []);
    return (
        <Stack spacing={3}>


            <Autocomplete
                multiple
                id="size-small-standard-multi"
                size="small"
                value={formObj.Fqtreportstatus||[]}
                getOptionSelected={(option, value) => option.name === value.name}
                options={reportStatus}
                getOptionLabel={(option) => option.name}
                //defaultValue={[top100Films[13]]}
                onChange={(event, newValue) => handleChange(event, newValue)}

                
                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant="standard"
                        label="Report Status "
                        //placeholder="Favorites"
                        onChange={autoTextReportStatus}

                    />
                )}
            />


        </Stack>
    );
}

// Top 100 films as rated by IMDb users. http://www.imdb.com/chart/top
